import {
  CallToAction,
  CallToActionProps
} from 'components/02-molecules/CallToAction';
import { IPaywall } from 'types';
import { H3 } from 'components/01-atoms/Heading';

export const DarkFullWidthCTA = ({
  dek,
  paywall,
  headingText,
  priceDisclaimer,
  linkConfig
}: Partial<CallToActionProps> & {
  headingText: string;
  paywall: IPaywall;
}) => (
  <CallToAction
    isFullWidth
    dek={dek}
    color="dark"
    heading={
      <H3
        classes="u-text--uppercase-xl text-network-white narrow-x:text-20"
        headingText={headingText}
      />
    }
    linkConfig={linkConfig}
    price={paywall?.price}
    priceDuration={paywall?.priceDuration}
    priceDisclaimer={priceDisclaimer}
    discountPrice={paywall?.discountPrice}
    discountCode={paywall?.discountCode}
    classes="mt-12 wide:mt-0"
  />
);
